/**
 * Validação/normalização de URL do site do cliente (espelha
 * back/api/utils/url.py). Armazenamos o hostname normalizado em
 * clients.domain / ad_accounts.domain.
 *
 * O backend revalida — isto serve só para feedback imediato no formulário.
 */

const HOST_RE =
  /^(?=.{1,253}$)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}$/

/**
 * Devolve o hostname normalizado, ou null se vazio.
 * Lança Error se a URL for inválida.
 */
export function normalizeDomain(raw) {
  if (raw == null) return null
  const text = String(raw).trim()
  if (!text) return null

  let host
  try {
    const candidate = text.includes('://') ? text : `http://${text}`
    host = new URL(candidate).hostname.toLowerCase()
  } catch {
    host = text.toLowerCase().split('/')[0].split(':')[0]
  }
  // Preserva o host como veio (inclui www. e subdomínios como blog.).
  // Só removemos esquema, path, query, fragmento e porta.

  if (!host || !HOST_RE.test(host)) {
    throw new Error(
      `URL inválida: "${raw}". Informe um domínio válido (ex.: exemplo.com.br).`
    )
  }
  return host
}

/** true se a URL é válida e não-vazia. */
export function isValidDomain(raw) {
  try {
    return !!normalizeDomain(raw)
  } catch {
    return false
  }
}
